import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import Loader from '~/prix/react/components/loader'
import Questionnaire from './general/questionnaire/questionnaire.screen'
import CreateQuestionnaire from './general/questionnaire/createQuestionnaire.screen'
import ListQuestionnaire from './general/questionnaire/listQuestionnaire.screen'
import UpdateQuestionnaire from './general/questionnaire/updateQuestionnaire.screen'
import QuestionnaireAnswerScreen from './general/questionnaire/answer/questionnaireAnswer.screen'
import NeighborhoodEditCoverageAreaScreen from './geo/neighborhood/editCoverageArea/neighborhoodEditCoverageArea.screen'
import HealthUnitEditCoverageAreaScreen from './publicHealth/healthUnit/editCoverageArea/healthUnitEditCoverageArea.screen'
import HealthTeamEditCoverageAreaScreen from './publicHealth/healthTeam/editCoverageArea/healthTeamEditCoverageArea.screen'
import HealthProfessionalEditCoverageAreaScreen from './publicHealth/healthProfessional/editCoverageArea/healthProfessionalEditCoverageArea.screen'
import PatchNotesScreen from './general/patchNotes/components/patchNotes.screen'
import SystemAndInfoScreen from './general/systemAndInformation/components/systemAndInfo.component'
import * as Sentry from '@sentry/react'
import { HelmetTitleUpdater } from '~/components/utils/hooks/useHelmet'
import LlmChatCreateScreen from './llmChat/create/llmChatCreate.screen'
import LlmChatGetScreen from './llmChat/get/llmChatGet.screen'
import LlmChatBaseScreen from './llmChat/llmChatBase.screen'
import LlmChatArchivedScreen from './llmChat/archived/llmChatArchived.screen'
import DrawerLayout from '~/components/drawer/drawer'
import UserFetchScreen from './general/user/fetch/components/userFetch.screen'
import UserListScreen from './general/user/list/components/userList.screen'
import UserManagementAccessGuard from './general/user/userManagementAccessGuard'
import UserUpsertScreen from './general/user/userUpsert.screen'
import SentinelScreen from './sentinel/sentinel.screen'
import InsightListScreen from './insight/insightList.screen'
import EmergencyDispatchFormScreen from './rural/emergencyDispatch/emergencyDispatchForm.screen'
import EmergencyDispatchListScreen from './rural/emergencyDispatch/emergencyDispatchList.screen'

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

export default function Router() {
  return (
    <BrowserRouter>
      <HelmetTitleUpdater />

      <React.Suspense fallback={<Loader />}>
        <SentryRoutes>
          <Route path='/' element={<SentinelScreen />} />
          <Route path='/index.html' element={<SentinelScreen />} />
          <Route path='/app/sentinel' element={<Navigate replace to='/' />} />
          <Route path='/app/insights' element={<InsightListScreen />} />
          <Route path='/a/:hash' element={<QuestionnaireAnswerScreen />} />

          <Route path='/app/ai' element={<LlmChatBaseScreen />}>
            <Route path='' element={<LlmChatCreateScreen />} />
            <Route path=':chatId' element={<LlmChatGetScreen />} />
          </Route>

          <Route path='/app/ai/archived' element={<LlmChatBaseScreen isArchived />}>
            <Route path='' element={<LlmChatArchivedScreen />} />
            <Route path=':chatId' element={<LlmChatGetScreen isArchived />} />
          </Route>

          <Route path='/app/neighborhoods' element={<NeighborhoodEditCoverageAreaScreen />} />
          <Route path='/app/health-units' element={<HealthUnitEditCoverageAreaScreen />} />
          <Route path='/app/health-teams' element={<HealthTeamEditCoverageAreaScreen />} />
          <Route
            path='/app/health-professionals'
            element={<HealthProfessionalEditCoverageAreaScreen />}
          />
          <Route path='/app' element={<DrawerLayout />}>
            <Route path='questionnaire/answer/:questionnaireId' element={<Questionnaire />} />
            <Route path='questionnaire/create' element={<CreateQuestionnaire />} />
            <Route path='questionnaire/list' element={<ListQuestionnaire />} />
            <Route path='questionnaire/update/:id' element={<UpdateQuestionnaire />} />
            <Route path='attendances' element={<EmergencyDispatchListScreen />} />
            <Route path='attendances/create' element={<EmergencyDispatchFormScreen />} />
            <Route path='attendances/update/:id' element={<EmergencyDispatchFormScreen />} />
            <Route path='patch-notes' element={<PatchNotesScreen />} />
            <Route path='system-information' element={<SystemAndInfoScreen />} />
            <Route path='profile' element={<UserFetchScreen />} />
            <Route
              path='users'
              element={
                <UserManagementAccessGuard>
                  <UserListScreen />
                </UserManagementAccessGuard>
              }
            />
            <Route
              path='users/create'
              element={
                <UserManagementAccessGuard>
                  <UserUpsertScreen />
                </UserManagementAccessGuard>
              }
            />
            <Route
              path='users/:id'
              element={
                <UserManagementAccessGuard>
                  <UserFetchScreen />
                </UserManagementAccessGuard>
              }
            />
            <Route
              path='users/update/:id'
              element={
                <UserManagementAccessGuard>
                  <UserUpsertScreen />
                </UserManagementAccessGuard>
              }
            />
          </Route>
          <Route path='*' element={<div>Not found</div>} />
        </SentryRoutes>
      </React.Suspense>
    </BrowserRouter>
  )
}
